<ng-container *ngIf="items">
  <ng-container *ngIf="items.length <= 2; else collapsedList">
    <ng-container
      *ngFor="let item of items"
      [ngTemplateOutlet]="itemTplRef"
      [ngTemplateOutletContext]="{
        columnType: column.type,
        item: item
      }">
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #collapsedList>
  <!-- first item -->
  <ng-container
    [ngTemplateOutlet]="itemTplRef"
    [ngTemplateOutletContext]="{
      columnType: column.type,
      item: items[0]
    }">
  </ng-container>

  <!-- following items in popover -->
  <ng-container
    [ngTemplateOutlet]="popover"
    [ngTemplateOutletContext]="{
      columnType: column.type,
      items: items
    }">
  </ng-container>

  <!-- link to display popover -->
  <a
    (click)="openPopover(popoverTrigger)"
    cdkOverlayOrigin
    #popoverTrigger="cdkOverlayOrigin"
    class="alc-icon-and-name">
    <ng-container *ngIf="!isPopoverOpened; else close">
      +&nbsp;{{ items.length - 1 }}&nbsp;<span translate="others"></span>
      <mat-icon>expand_more</mat-icon>
    </ng-container>
    <ng-template #close>
      <span translate="close"></span>
      <mat-icon>expand_less</mat-icon>
    </ng-template>
  </a>
</ng-template>

<!-- template : item in list, can be a text or a link -->
<ng-template #itemTplRef let-columnType="columnType" let-item="item">
  <ng-container [ngSwitch]="columnType">
    <div *ngSwitchCase="TableColumnTypeEnum.LIST" class="alc-ellipsis" [matTooltip]="item" appMatTooltipShowIfTruncated>
      {{ item }}
    </div>
    <div *ngSwitchCase="TableColumnTypeEnum.LINK_LIST">
      <app-table-link [link]="item"></app-table-link>
    </div>
  </ng-container>
</ng-template>

<!-- template : popover -->
<ng-template #popover let-columnType="columnType" let-items="items">
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="popoverTrigger"
    [cdkConnectedOverlayOpen]="isPopoverOpened"
    [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
    (detach)="closePopover()">
    <div class="popover-container minimal-scrollbar">
      <ng-container *ngFor="let item of items; first as first">
        <ng-container
          *ngIf="!first"
          [ngTemplateOutlet]="itemTplRef"
          [ngTemplateOutletContext]="{
            columnType: columnType,
            item: item
          }"></ng-container>
      </ng-container>
    </div>
  </ng-template>
</ng-template>
